// test1439
(1439 && 0);
